module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/vdige5-caee1bd513df4dfdddd9ad23ea123050.jpg";